(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('modality', {
            parent: 'entity',
            url: '/modality',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Modalities'
            },
            ncyBreadcrumb: {
                label: 'Modalities',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modality/modalities.html',
                    controller: 'ModalityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('modality-detail', {
            parent: 'entity',
            url: '/modality/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Modality'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modality/modality-detail.html',
                    controller: 'ModalityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Modality', function($stateParams, Modality) {
                    return Modality.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'modality',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('modality-detail.edit', {
            parent: 'modality-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modality/modality-dialog.html',
                    controller: 'ModalityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modality', function(Modality) {
                            return Modality.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modality.new', {
            parent: 'modality',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modality/modality-dialog.html',
                    controller: 'ModalityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modality', null, { reload: 'modality' });
                }, function() {
                    $state.go('modality');
                });
            }]
        })
        .state('modality.edit', {
            parent: 'modality',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modality/modality-dialog.html',
                    controller: 'ModalityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modality', function(Modality) {
                            return Modality.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modality', null, { reload: 'modality' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modality.delete', {
            parent: 'modality',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modality/modality-delete-dialog.html',
                    controller: 'ModalityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Modality', function(Modality) {
                            return Modality.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modality', null, { reload: 'modality' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
